import { Spinner } from '@cimplico/components';
import { useEffect, useState } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { useIsOnboarded } from '../hooks/use-is-onboarded';
import AutoAcceptInvitation from '../components/auto-accept-invitation/AutoAcceptInvitation';

import OnboardingProfileIcon from '../features/onboarding/OnboardingProfileIcon';

function AutoAcceptInvitationPage(): JSX.Element {
    const [params, setParams] = useSearchParams();
    const [loading, setLoading] = useState(true);
    const [invitationId, setInvitationId] = useState<string | null>();
    const { hasProfile, isLoading } = useIsOnboarded();

    useEffect(() => {
        setLoading(true);
        let invitationId = params.get('invitation');
        if (!invitationId) {
            invitationId = localStorage.getItem('invitation-id');
            if (invitationId) {
                localStorage.removeItem('invitation-id');
                setParams((p) => {
                    p.append('invitation', invitationId as string);
                    return p;
                });
            }
        }
        setInvitationId(invitationId);
        setLoading(false);
    }, [params, setParams]);

    if (isLoading || loading) {
        return <></>;
    }

    if (!invitationId) {
        return <Navigate to="/onboarding?step=join-firm" />;
    }

    return (
        <div className="w-screen h-screen flex justify-center pt-24">
            <div className="absolute top-4 right-4">
                <OnboardingProfileIcon />
            </div>

            {!hasProfile && (
                <div className="max-w-[450px] mx-auto pt-24">
                    <Navigate to="/onboarding?step=join-firm" />
                </div>
            )}
            {hasProfile && invitationId && <AutoAcceptInvitation id={invitationId} />}
        </div>
    );
}
export default AutoAcceptInvitationPage;
